import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AdvMessageService } from 'shared/src/common/public_api';
import { AppState, selecCompanyInCommonState } from '../../../app-state.index';
import { PermissionsService } from '../../permissions/permissions.service';
import { CompaniesService } from '../../services/companies.service';

@Component({
  selector: 'company-rating',
  templateUrl: './company-rating.component.html',
  styleUrls: ['./company-rating.component.scss']
})
export class CompanyRatingComponent implements OnInit {
  companyId: number;
  isKesherAdminRole: boolean;
  constructor(private companyService: CompaniesService, private store: Store<AppState>,
    private permissionService: PermissionsService,
    private messageService: AdvMessageService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.store.select(selecCompanyInCommonState).subscribe((data: any) => {
      if (data) {
        this.companyId = data.companyId;
        this.selectedRatingValue = null;
        this.selectedRatingImage = null;
        this.loadCompanyRating(); // טען דירוג לפי החברה החדשה
      }
    });
    this.isKesherAdminRole = this.permissionService.isKesherAdminRole();
  }
  loadCompanyRating() {
    this.companyService.getRating().subscribe(res => {
      if (res.succeeded && res.rating != null) {
        this.selectedRatingValue = res.rating;
        const selected = this.ratingOptions.find(r => r.value === res.rating);
        this.selectedRatingImage = selected?.image || null;
        this.cdr.markForCheck(); // מוודא שהשינויים נראים על המסך
      }
    });
  }
  selectedRatingImage: string | null = null;
  selectedRatingValue: number | null = null;
  url:string="assets/images/PhotosVarious/"
  ratingOptions = [
    { value: 1, image: this.url+'bad.png', label: 'לקוח גרוע' },
    { value: 2, image: this.url+'regular.png', label: 'לקוח רגיל' },
    { value: 3, image: this.url+'vip.png', label: 'לקוח VIP' },
    { value: 4, image: this.url+'super_vip.png', label: 'לקוח VIP על' }
  ];

  selectRating(value: number, imageUrl: string,label:string) {
    this.selectedRatingValue = value;
    this.selectedRatingImage = imageUrl
    this.messageService.successMessage("החברה הוגדרה כ"+ label);
    this.companyService.saveRating(this.selectedRatingValue).subscribe(res => {
      console.log(res);
    });
  }
}
